import styled from "styled-components";
import { Header } from "antd/es/layout/layout";
import { Link } from "react-router-dom";
import { hideOnMaxWidth } from "src/styles/mixins";

import Logo from "../../assets/logo.svg";

export const HeaderStyled = styled(Header)(({ theme }) => ({
  background: theme.colorSecondary,
  color: "#333",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "16px 20px",
  fontSize: "16px",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
}));

export const TopRow = styled("div")(({ theme }) => ({
  maxWidth: theme.screenLGMax,
  margin: "0 auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
}));

export const LeftZone = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "24px",
});

export const LogoImage = styled(Logo)({
  height: "32px",
  width: "192px",
});

export const AuthWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  width: "100%",
  justifyContent: "end",
});

export const IconStyled = styled("span")(({ theme }) => ({
  color: theme.colorPrimary,
  fontSize: "18px",
}));

export const SelectGroup = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  paddingRight: "12px",
  borderRight: "1px solid #ddd",
});

export const RegionSelectStyled = styled("select")(({ theme }) => ({
  ...hideOnMaxWidth(theme.screenMDMax),
  padding: "6px 10px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  fontSize: "14px",
  backgroundColor: "white",
  color: "#333",
}));

export const AddBusinessButton = styled(Link)(({ theme }) => ({
  padding: "8px 8px",
  borderRadius: "20px",
  fontSize: "14px",
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  color: "#fff",
  background: `linear-gradient(90deg, ${theme.colorAccent}, #27ae60)`,
  height: "2rem",
  whiteSpace: "nowrap",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
  "&:hover": {
    backgroundColor: `linear-gradient(90deg, #1e7c43, ${theme.colorAccent})`,
    color: "#fff",
  },
}));

export const AddBusinessButtonTextStyled = styled("span")(({ theme }) => ({
  ...hideOnMaxWidth(theme.screenXSMax),
}));
